(function () {
  if (!document.body.classList.contains('template-product')) return;

  function isThemeWishlist(el) {
    return Boolean(el && (el.matches('[data-wishlist-button]') || el.closest('[data-wishlist-button]')));
  }

  function isSwymNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isThemeWishlist(el)) return false;

    var id = el.id || '';
    var className = typeof el.className === 'string' ? el.className : '';

    if (id.indexOf('swym') !== -1) return true;
    if (className.indexOf('swym') !== -1) return true;
    if (el.matches('.swym-button, .swym-btn-container, .swym-button-bar, .swym-inject')) return true;

    return false;
  }

  function hideNode(el) {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
    el.hidden = true;
  }

  function cleanProductInfo(root) {
    if (!root) return;

    root.querySelectorAll('[class*="swym"], [id*="swym"], .swym-button, .swym-btn-container, .swym-button-bar').forEach(function (el) {
      if (!isSwymNode(el)) return;
      hideNode(el);
    });

    var title = root.querySelector('.product__title');
    if (!title) return;

    title.querySelectorAll('button, [class*="swym"], [id*="swym"]').forEach(function (el) {
      if (!isSwymNode(el)) return;
      hideNode(el);
    });

    Array.prototype.forEach.call(title.children, function (child) {
      if (child.matches('h1, a.product__title, .product__title-rating, .product__title-rating--link')) return;
      if (isSwymNode(child) || child.tagName === 'BUTTON') hideNode(child);
    });
  }

  function run() {
    document.querySelectorAll('product-info, [id^="MainProduct"], .product__info-wrapper').forEach(cleanProductInfo);
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }

  window.addEventListener('load', run);

  var observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });
})();
